export const initNetwork = function (config) {
  $('.flixx_network').each(function () {
    let
      $elNetwork = $(this),
      $elNetworkFilterCompetencies = $elNetwork.find('.filter-competencies'),
      $elNetworkFilterCountry = $elNetwork.find('.filter-country'),
      $elNetworkFilterStates = $elNetwork.find('.filter-states'),
      filterCompetencies = [],
      filterCountry = [],
      filterStates = [],
      $items = $elNetwork.find('table > tbody > tr')
    ;

    $items.each(function () {
      const rawCompetencies = $(this).attr('data-filter-competencies') || '';
      if (rawCompetencies) {
        rawCompetencies.split(',').forEach(competency => {
          const trimmedCompetency = competency.trim();
          if (trimmedCompetency) {
            filterCompetencies.push(trimmedCompetency);
          }
        });
      }

      const rawCountry = $(this).attr('data-filter-country') || '';
      const trimmedCountry = rawCountry.trim();
      if (trimmedCountry) {
        filterCountry.push(trimmedCountry);
      }
    });

    // remove duplicates
    filterCompetencies = [...new Set(filterCompetencies.filter(item => item !== ''))];
    filterCountry = [...new Set(filterCountry.filter(item => item !== ''))];

    filterCompetencies.sort((a, b) => a.localeCompare(b));
    filterCountry.sort((a, b) => a.localeCompare(b));

    // set filter options
    filterCompetencies.forEach(entry => {
      $elNetworkFilterCompetencies.append($('<option>', {
        value: entry,
        text: entry
      }));
    });
    filterCountry.forEach(entry => {
      $elNetworkFilterCountry.append($('<option>', {
        value: entry,
        text: entry
      }));
    });

    $elNetworkFilterCompetencies.on('change', function () {

      // reset other select
      $elNetworkFilterCountry.prop('selectedIndex', 0);
      $elNetworkFilterStates.prop('selectedIndex', 0);

      let value = this.value;
      $items.each(function () {
        $(this).removeClass('d-none');
        if ((value !== 'reset') && ($(this).attr('data-filter-competencies').indexOf(value) === -1)) {
          $(this).addClass('d-none');
        }
      });

      // re-color the table stripes
      $elNetwork.find('table').removeClass('table-striped');
      $elNetwork.find('table > tbody > tr:not(.d-none)').each(function (index) {
        $('td', this).css("background-color", !!(index & 1)?  "#ffffff": "#e8f3f7");
      });

      initMap();
    });

    // State change handler
    $elNetworkFilterStates.on('change', function () {
      // Reset other select
      $elNetworkFilterCompetencies.prop('selectedIndex', 0);

      let value = this.value;
      $items.each(function () {
        $(this).removeClass('d-none');
        if ((value !== 'reset') && ($(this).attr('data-filter-states').indexOf(value) === -1)) {
          $(this).addClass('d-none');
        }
      });

      // re-color the table stripes
      $elNetwork.find('table').removeClass('table-striped');
      $elNetwork.find('table > tbody > tr:not(.d-none)').each(function (index) {
        $('td', this).css("background-color", !!(index & 1) ? "#ffffff" : "#e8f3f7");
      });

      initMap();
    });

    $elNetworkFilterCountry.on('change', function () {
      // Reset other select
      $elNetworkFilterCompetencies.prop('selectedIndex', 0);
      $elNetworkFilterStates.prop('selectedIndex', 0);
      $elNetworkFilterStates.parent('div').addClass('d-none');

      // Remove all options, except the first (default) option
      $elNetworkFilterStates.find('option').not(':first').remove();
      filterStates = [];

      // Shows results in result list, adds states to select
      let value = this.value;
      $items.each(function () {
        $(this).removeClass('d-none');
        if ((value !== 'reset') && ($(this).attr('data-filter-country') !== value)) {
          $(this).addClass('d-none');
        }else{
          const rawStates = $(this).attr('data-filter-states') || '';
          if (rawStates) {
            rawStates.split(',').forEach(states => {
              const trimmedStates = states.trim();
              if (trimmedStates) {
                filterStates.push(trimmedStates);
              }
            });
          }
        }
      });

      // re-color the table stripes
      $elNetwork.find('table').removeClass('table-striped');
      $elNetwork.find('table > tbody > tr:not(.d-none)').each(function (index) {
        $('td', this).css("background-color", !!(index & 1)?  "#ffffff": "#e8f3f7");
      });

      // Fills states select with new results
      filterStates = [...new Set(filterStates.filter(item => item !== ''))];
      filterStates.sort((a, b) => a.localeCompare(b));
      filterStates.forEach(entry => {
        $elNetworkFilterStates.append($('<option>', {
          value: entry,
          text: entry
        }));
      });

      // Shows or hides states select if it's empty
      if ($elNetworkFilterStates.find('option').length > 1) {
        $elNetworkFilterStates.parent('div').removeClass('d-none');
      } else {
        $elNetworkFilterStates.parent('div').addClass('d-none');
      }

      initMap();
    });
  });


}
